module.exports = __webpack_public_path__ + "img/BT.f14bdee5.svg";